module.exports = __webpack_public_path__ + "img/title_back.81369f56.png";